import { PublicEnvironmentBase } from "./app/shared/public-providers";

declare const window: any;
window.ENVIRONMENT = window.ENVIRONMENT || {};

// NOTE: Any changes to the Environment interface below will also
//       require additional updates to the following:
//          1) ../deploy/*.yaml
//          2) ../local.environment.js
export interface Environment extends PublicEnvironmentBase {
  captchaKey: string;
  turnstileSiteKey: string;
  showSupplierFormFeature: boolean;
  researchProposalWebformEnabled: boolean;
  cmsBaseUrl: string;
  storageBucketBaseUrl: string;
  contentHubEnabled: boolean;
  emailSignupWorkerUrl?: string;
  midsouthFeedbackWorkerUrl?: string;
  louisianaFeedbackWorkerUrl?: string;
  hiringWorkerUrl?: string;
}

export const environment: Environment = {
  ...window.ENVIRONMENT,
};
